<script>
  import { createEventDispatcher, getContext } from 'svelte';
  import ComponentEvents from '@utils/component-events';

  import Photos from './parts/Photos.svelte';
  import Rating from './parts/Rating.svelte';
  import Reviews from './parts/Reviews.svelte';
  import Like from './parts/Like.svelte';
  import BrowserUtils from '@utils/browser-utils';

  import BookmarkButton from '@app-components/BookmarkButton.svelte';
  import RecObjectOptionMenu from '@app-components/RecObjectOptionMenu.svelte';
  import HideReportedContentOverlay from '@app-components/report/HideReportedContentOverlay.svelte';
  export let recObject;
  export let recs = [];
  export let showActionBar = true;
  export let customGroupStore;

  export let group;
  export let displayRecObjectDetailView;
  export let forceShowNames = false;

  let isNoteFocused = false;
  let optionsMenu;
  let focusBrokenLink = false;
  let reportedContentKey = `rec_${recObject.id}`;
  let reportedContent = getContext('reportedContent');
  $: reportedContentId = $reportedContent[reportedContentKey] || null;

  $: canEditNote = group && group.permissions.edit;
  $: hasNoteWithContents = recs && recs.filter((r) => r.user_note != '').length > 0;
  $: hasContributors = group && group.users.length > 1;
  $: showReviews = canEditNote || hasNoteWithContents || hasContributors;

  const dispatch = createEventDispatcher();

  const onClick = (event, afterDisplay) => {
    event.preventDefault();

    if (!isNoteFocused) {
      displayRecObjectDetailView(event, afterDisplay);

      ComponentEvents.trigger('rec-object-click', { recObject });
    }
  };

  let dispatchFullRecObjectRendered = () => {
    dispatch('rec-object-fully-rendered');
  };
</script>

<style style="text/scss" lang="scss">
  @import '.././../vendor/design-system.scss';
  .rec-object {
    margin-top: 20px;
    width: calc(100% + 40px);
    background: #ffffff;
    box-shadow: 0px 8px 50px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    padding: 0px;
    position: relative;
    margin-left: -20px;

    &.reported-content-overlay {
      box-shadow: none;
    }

    .rec-object-center {
      display: flex;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 20px;
      min-height: 50px;

      .rec-object-title {
        flex: 1;
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        padding-right: 10px;
      }

      .rec-object-rating {
        flex-shrink: 0;
      }
    }

    .rec-object-reviews {
      padding: 20px;
      padding-top: 10px;
    }

    .rec-object-photos {
      position: relative;

      .photos-photo {
        border-radius: 0px !important;
        object-fit: cover;
        width: 100% !important;
        height: 260px !important;
        min-height: 260px !important;
        max-height: 260px !important;

        &.with-background {
          background: #eee;
        }

        &.contain {
          object-fit: contain;
          background-color: white;
          border-bottom: 1px solid $neutral-input-gray;
        }
      }
    }

    .rec-object-bottom-bar {
      display: flex;
      align-items: center;
      padding-bottom: 20px;

      .rec-object-comments-and-link {
        flex: 1;
        margin-left: 20px;
        display: flex;

        .rec-object-like {
          margin-right: 16px;
        }

        .rec-object-comments {
          display: flex;
          align-items: center;
          margin-left: 6px;

          span {
            font-weight: 400;
            font-size: 14px;
            line-height: 17px;
            color: #1a1a1a;
            margin-left: 7px;
          }
        }
      }

      .rec-object-save-btn {
        flex-shrink: 0;
        margin-right: 16px;
      }
    }
    .broken-link-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px 12px 12px;
      gap: 10px;
      background: #ff5567;
      color: #fff;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      border-radius: 8px 8px 0px 0px;
      // position: relative;

      .left {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px;
        gap: 10px;
        font-weight: 600;

        .icon-alert {
          width: 16px;
        }
      }
      .right {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px;
        gap: 12px;

        .link-button-edit {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 8px;
          cursor: pointer;

          .icon-edit {
            width: 12px;
          }
          &:hover {
            color: lightgrey !important;
            svg {
              path {
                fill: lightgrey !important;
              }
            }
          }
        }

        .vertical-line {
          width: 1px;
          height: 16px;
          background: #ececec;
        }

        .detail-options-button {
          position: relative;
          color: #000;
        }
      }
    }
  }

  * :global(.ui-save-it) {
    border: 0px !important;
  }

  * :global(.rec-object-actions svg path) {
    fill: white !important;
  }

  * :global(.review-container) {
    height: unset !important;
  }

  * :global(.single-review.expand) {
    position: unset !important;
    left: unset !important;
    right: unset !important;
    z-index: unset !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
    background: white !important;
    border-radius: unset !important;
    box-shadow: unset !important;
    padding-bottom: unset !important;
    margin-top: -10px !important;
  }

  * :global(.add-height-above-review) {
    height: 0px !important;
  }

  * :global(.rec-object-actions.regular svg) {
    filter: drop-shadow(rgba(0, 0, 0, 0.8) 0px 0px 8px);
  }

  * :global(.ui-photos.regular) {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    overflow: hidden;
  }

  * :global(.like span) {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 17px !important;
    color: #1a1a1a !important;
    margin-left: 7px !important;
    opacity: 1 !important;
  }
</style>

<div
  on:click={onClick}
  data-rec-object-id={recObject.id}
  use:dispatchFullRecObjectRendered
  class="rec-object rec-object-grid-view rec-object-mobile"
  class:reported-content-overlay={reportedContentId}
  id="grid-rec-object-{recObject.id}">
  <div class="rec-object-container">
    <div class="rec-object-photos">
      {#if showActionBar}
        {#if recObject.weblink_broken}
          <div class="broken-link-top broken-link-rec-object">
            <div class="left">
              <img class="icon-alert" src="/images/alert-white.png" width="16px" />
              Broken Link
            </div>
            <div class="right">
              <div
                class="link-button-edit"
                on:click|preventDefault|stopPropagation={() => {
                  optionsMenu.displayRecObjectFormModal();
                  focusBrokenLink = true;
                }}>
                <svg
                  class="icon-edit"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 9.49965L0 12H2.50035L9.87804 4.62231L7.37769 2.12196L0 9.49965ZM11.805 2.69537C12.065 2.43534 12.065 2.01195 11.805 1.75191L10.2481 0.195027C9.98806 -0.065009 9.56466 -0.065009 9.30463 0.195027L8.08446 1.4152L10.5848 3.91554L11.805 2.69537Z"
                    fill="white" />
                </svg> Fix
              </div>
              <div class="vertical-line" />
              <div class="detail-options-button">
                <RecObjectOptionMenu
                  bind:this={optionsMenu}
                  mobile={true}
                  recObjectId={recObject.id}
                  detailsViewOption={true}
                  bind:focusBrokenLink={focusBrokenLink}
                  styleAsBrokenLink={true}
                  actionStyle="" />
              </div>
            </div>
          </div>
        {:else}
          <div class="detail-options-button">
            <RecObjectOptionMenu
              mobile={true}
              recObjectId={recObject.id}
              detailsViewOption={true}
              actionStyle="top: -2px; right: 0px; padding: 10px; padding-right: 15px;" />
          </div>
        {/if}
      {/if}

      <div style="height: 260px;">
        <Photos
          customGroupStore={customGroupStore}
          mobile={true}
          recObjectId={recObject.id}
          useFancyBox={false}
          viewStyle="grid"
          maxBigDotsShown={7}>
          <svelte:fragment slot="img" let:photo let:showPlaceholderImage>
            <img
              style={photo.background_color ? `background-color: ${photo.background_color} !important;` : ''}
              class="photos-photo with-background {photo.display_style}"
              on:error={showPlaceholderImage}
              src={photo.view_urls.rect_size || photo.view_urls.full_size} />
            <div class="photos-photo image-subtle-overlay"></div>
          </svelte:fragment>
        </Photos>
      </div>
    </div>
    <div class="rec-object-center">
      <div class="rec-object-title">{@html recObject.name1}</div>
      <div class="rec-object-rating">
        <Rating
          customGroupStore={customGroupStore}
          mobile={true}
          trackThenGoToRating={displayRecObjectDetailView}
          recObjectId={recObject.id}
          listView={true} />
      </div>
    </div>
    <div class="rec-object-reviews">
      {#if forceShowNames || showReviews}
        <Reviews
          customGroupStore={customGroupStore}
          mobile={true}
          recObjectId={recObject.id}
          recIds={recs.map((x) => x.id)}
          lines={4}
          forceShowNames={forceShowNames}
          on:click={displayRecObjectDetailView}
          on:focus={() => (isNoteFocused = true)}
          on:blur={() => (isNoteFocused = false)} />
      {/if}
    </div>
    <div class="rec-object-bottom-bar">
      <div class="rec-object-comments-and-link">
        <div class="rec-object-like">
          <Like
            customGroupStore={customGroupStore}
            style="margin-top: 0px;"
            recObjectId={recObject.id}
            displayCount={true}
            mobile={true} />
        </div>
        <div
          class="rec-object-comments"
          on:click|preventDefault|stopPropagation={(e) => {
            let focusAndScroll = async function () {
              let elem =
                document.querySelector('.detail-mobile-comments .empty-comments-container') ||
                document.querySelector('.detail-mobile-comment-label');

              let container = document.querySelector('.detail-view-modal .modal__container');

              setTimeout(() => {
                BrowserUtils.goToElementWithinContainer(elem, container, {
                  behavior: 'smooth',
                });
              }, 0);
            };

            onClick(e, focusAndScroll);
          }}>
          <svg
            height="18"
            class="rec-object-comment-btn"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none">
            <path
              d="M9 1C4.584 1 1 4.20129 1 8.20291C1.01196 9.165 1.22668 10.1137 1.63012 10.9872C2.03357 11.8606 2.61667 12.639 3.34133 13.2716L3.13333 16.5583C3.12961 16.6358 3.14736 16.7129 3.18462 16.7809C3.22188 16.849 3.27721 16.9055 3.3445 16.9441C3.41179 16.9827 3.48843 17.002 3.56598 16.9998C3.64353 16.9977 3.71898 16.9741 3.784 16.9318L6.584 15.0644C7.36961 15.2897 8.18273 15.4047 9 15.4058C13.416 15.4058 17 12.2045 17 8.20291C17 4.20129 13.416 1 9 1Z"
              stroke="#1A1A1A"
              stroke-width="1.5"
              class="s-RLud9ny07R5l" />
          </svg>

          {#if recObject.comments && recObject.comments.total > 0}
            <span>{recObject.comments.total}</span>
          {/if}
        </div>
      </div>

      <div class="rec-object-save-btn">
        <BookmarkButton rec={recs[0]} viewStyle="rec-object" mobile={true} />
      </div>
    </div>
  </div>
  {#if reportedContentId}
    <HideReportedContentOverlay
      noBorderRadius={true}
      text="Show Rec"
      reportedContentId={reportedContentId}
      reportedContentKey={reportedContentKey} />
  {/if}
</div>
